import React, {useState, useEffect, Fragment} from "react" ;
import { Globals, getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import {getContactMessages} from "root/DataFunctions/MessageDataFns";
import ChildMessageTable from "root/Tables/ChildMessageTable";
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";
import {useRecoilValue} from "recoil";
import {childDetailsState} from "root/recoil/childDetailsState";
import {MessageFilters, MessageType} from "root/DataFunctions/Constants";

const SentMessages = (props) => {
    const [messages, setMessages] = useState("");
    const [loading, setLoading] = useState(false);
    const childDetails = useRecoilValue(childDetailsState)

    const shouldShowToDropdown = true;

    const [renderAddMessagingModal, showAddMessagingModal] = useModalAddPost((result) =>
    {
        if(result === "saved") {
            handleGetSentMessages();
        }
    })

    const handleShowMessage = (message, mode, page) => {
        const child_uid = childDetails ? childDetails[0].adoptee_user_id : null;
        showAddMessagingModal(mode, child_uid, message.post_id, shouldShowToDropdown, MessageType.MESSAGE_TYPE_MESSAGE, page);
    }

    const handleGetSentMessages = () => {
        setLoading(true);

        getContactMessages( 'user', 'user', MessageFilters.SENT, MessageType.MESSAGE_TYPE_MESSAGE,(response) =>
        {
            setMessages(getDataFromResponse(response));
            setLoading(false);
        })
    }

    useEffect(() => {
        handleGetSentMessages();
    }, []);

    return (
        <>
            <div style={{flex: "1"}}>
                <div className="child_breadcrumb child_breadcrumb-main">
                    <div className="child_breadcrumb_inner">
                        <h2 className="child_breadcrumb_title">Sent Messages</h2>
                    </div>
                </div>

                <div className="child-message-wrap">
                    <div className="child-message-table">
                        {messages && 
                            <ChildMessageTable
                                tableClass='passport-table-child'
                                loading={loading}
                                data={messages}
                                page="sent"
                                showMessageDetail={handleShowMessage}
                            />
                        }  
                    </div>
                </div>
            </div>

            {renderAddMessagingModal(props)}
        </>
    );
}

export default SentMessages;
